import {
  TTrafficSourceSummaryResponse,
  TrafficSourceSummary,
} from "../entities/traffic-source-summary-response";

export type TTraficSourceSummaryTableHead = {
  header: string;
  accessor: string;
};

export type TTraficSourceSummaryTableBody = {
  mediaType: string;
  vehicle: string;
  title: string;
  visitors: string;
  conversion: string;
};

export class TrafficSourceSummaryModel {
  static from(
    trafficSourceSummaryResponse: TTrafficSourceSummaryResponse
  ): TrafficSourceSummary {
    return {
      range: trafficSourceSummaryResponse.range,
      cards: trafficSourceSummaryResponse.cards.map((card) => {
        return {
          order: card.order,
          iconTitle: card.iconTitle,
          title: card.title,
          text: card.text,
          subText: card.subText,
          previousText: card.previousText,
          iconVariation: card.iconVariation,
          percentageVariation: card.percentageVariation,
          previousRange: card.previousRange,
        };
      }),
      trafficSourceSummary: {
        dataColumns: [
          {
            header: "Source",
            accessor: "mediaType",
            tooltipMessage: "The source from where the traffic is coming."
          },
          {
            header: "Medium",
            accessor: "vehicle",
            tooltipMessage: "The medium from where the traffic is coming."
          },
          {
            header: "URL",
            accessor: "title",
          },
          {
            header: "Unique visitors",
            accessor: "visitors",
          },
          {
            header: "Converted",
            accessor: "conversions",
          },
        ],

        dataRows: trafficSourceSummaryResponse.trafficSourceSummary.map(
          (traffic) => {
            return {
              mediaType: traffic.mediaType,
              vehicle: traffic.vehicle,
              title: traffic.title,
              conversions: `${traffic.conversions} (${traffic.percentageConversions})`,
              visitors: `${traffic.visitors} (${traffic.percentageVisitors})`,
            };
          }
        ),
      },
    };
  }
}
